module.exports = __webpack_public_path__ + "3878ea0f6c3a15b1c92bc1d1ad55fcef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fannie_mae_2022_chart.png
// module id = 1674
// module chunks = 0